<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        <v-btn text small @click="$router.back()">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          outlined
          class="mx-2"
          @click="downloadLink(proforma)"
        >
          <v-icon left> mdi-download </v-icon>
          Download
        </v-btn>
        <v-btn color="primary" @click="pay">
          <v-icon left> mdi-send </v-icon>
          Pay KES
          {{ parseFloat(amountToPay.replace(/,/g, "")) | currencyFormat }}
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="8" offset="2">
            <v-card-text class="elevation-1 my-1">
              <pdf style="width: 100%" :src="proforma" />
            </v-card-text>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import pdf from "vue-pdf";
import FileMixin from "@brainspore/celadon-base/mixin/FileMixin";
import { AuthService } from "@/packages/dashboard/modules/auth";
import examMixins from "@/packages/exams/examMixins";

export default {
  name: "examBookingPayments",
  components: { pdf },
  mixins: [FileMixin, examMixins],
  data: function () {
    return {
      payableAmount: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Exam/currentProgramme");
      v.$store.dispatch("Exam/examBookingProforma", to.params.code);
      window.document.title = "KISEB::Exam Payments";
      v.$store.dispatch("Dashboard/getStudentAmountToPay", {
        profileNo: v.studentRegistration.profileID,
        billAmount: v.amountPayable(),
      });
    });
  },
  mounted() {
    Event.$on("totalBookingAmount", (amount) => {
      this.payableAmount = amount;
    });
  },
  computed: {
    amountToPay() {
      return this.$store.getters["Dashboard/amountToPay"];
    },
    proforma() {
      return this.$store.getters["Exam/studentExamGetter"]("proforma");
    },
    user() {
      return AuthService.user;
    },
    studentRegistration() {
      return this.$store.getters["Exam/studentExamGetter"](
        "programmeRegistration",
      );
    },
  },
  methods: {
    amountPayable: function () {
      if (this.payableAmount > 0) {
        return this.payableAmount;
      } else {
        return this.studentRegistration["totalAmount"];
      }
    },
    pay: function () {
      const PhoneNo =
        this.user.profile.phoneNo.charAt(0) === "+"
          ? this.user.profile.phoneNo.slice(1)
          : this.user.profile.phoneNo.charAt(0) === "0"
            ? `254${this.user.profile.phoneNo.slice(1)}`
            : this.user.profile.phoneNo;
      const data = this.studentRegistration;
      this.$confirm.show({
        title: "Exam Booking Payment",
        rejectLabel: "Pay Later",
        text: `Payment for exam booking No. ${data["transactionID"]}`,
        onConfirm: () => {
          let payload = {
            payerID: data.profileID,
            sourceDocumentNo: data["transactionID"],
            serviceID: data.serviceCode,
            description: "Exam Payment",
            amount: parseFloat(this.amountToPay.replace(/,/g, ""))
              .toString()
              .toString(),
            accountNo: PhoneNo,
            email: this.user.profile.email,
            idNumber: this.user.profile.identificationDocumentNo,
            name: `${this.user.profile.firstName} ${this.user.profile.lastName}`,
            success_url: `${process.env.VUE_APP_URL}${
              this.$router.resolve({ name: "ExamBookings" }).href
            }`,
            fail_url: window.location.href,
          };

          payload = btoa(JSON.stringify(payload));
          // window.open(
          //   // `${process.env.VUE_APP_PAYGATE_CHECKOUT_URL}/?payload=${payload}`,
          //   "_blank"
          // );
          this.$checkout.pay(payload);
        },
        onCancel: () => {
          Event.$emit("ApiInfo", "Payment cancelled");
          this.$router.replace({ name: "ExamBookings" });
          this.$store.dispatch("Exam/studentBookings");
        },
      });
    },
    toInt: function (amount) {
      return parseInt(amount.replace(/,/g, ""));
    },
  },
  watch: {
    studentRegistration: function (val) {
      if (val) {
        this.$store.dispatch("Dashboard/getStudentAmountToPay", {
          profileNo: val.profileID,
          amount: this.amountPayable(),
        });
      }
    },
  },
};
</script>

<style scoped></style>
